import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  dokumente: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  dokumente (state) {
    return state.dokumente
  },
  dokument: (state) => (id) => {
    return state.dokumente.find(dokument => dokument.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadDokumente ({commit}) {
    commit('setLoading', true)
    console.log('Dokumente laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dokumente').onSnapshot(snapshot => {
      const dokumente = []
      snapshot.forEach(doc => {
        if (!doc.data().delete) {
          dokumente.push({
            ...doc.data(),
            id: doc.id
          })
        }
        commit('setLoadedDokumente', dokumente)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createDokument ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dokumente').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteDokumentData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dokumente').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteDokument', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateDokumentData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('dokumente').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateDokument', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedDokumente (state, payload) {
    state.dokumente = payload
  },
  createDokument (state, payload) {
    state.dokumente.push(payload)
  },
  updateDokument (state, payload) {
    const dokument = state.dokumente.find(dokument => {
      return dokument.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        dokument[key] = payload[key]
      }
    })
  },
  deleteDokument (state, payload) {
    let array = state.dokumente
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.dokumente = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dokumente_alt.js